import Activity from 'react-feather/dist/icons/activity';
import AlertCircle from 'react-feather/dist/icons/alert-circle';
import AlertTriangle from 'react-feather/dist/icons/alert-triangle';
import AlertOctagon from 'react-feather/dist/icons/alert-octagon';
import AlignCenter from 'react-feather/dist/icons/align-center';
import AlignLeft from 'react-feather/dist/icons/align-left';
import AlignRight from 'react-feather/dist/icons/align-right';
import Archive from 'react-feather/dist/icons/archive';
import ArrowDownRight from 'react-feather/dist/icons/arrow-down-right';
import ArrowLeft from 'react-feather/dist/icons/arrow-left';
import ArrowLeftCircle from 'react-feather/dist/icons/arrow-left-circle';
import ArrowRight from 'react-feather/dist/icons/arrow-right';
import ArrowRightCircle from 'react-feather/dist/icons/arrow-right-circle';
import ArrowUpRight from 'react-feather/dist/icons/arrow-up-right';
import Award from 'react-feather/dist/icons/award';
import BatteryCharging from 'react-feather/dist/icons/battery-charging';
import BellOff from 'react-feather/dist/icons/bell-off';
import Bell from 'react-feather/dist/icons/bell';
import BookOpen from 'react-feather/dist/icons/book-open';
import Calendar from 'react-feather/dist/icons/calendar';
import Camera from 'react-feather/dist/icons/camera';
import CameraOff from 'react-feather/dist/icons/camera-off';
import Check from 'react-feather/dist/icons/check';
import CheckCircle from 'react-feather/dist/icons/check-circle';
import CheckSquare from 'react-feather/dist/icons/check-square';
import ChevronDown from 'react-feather/dist/icons/chevron-down';
import ChevronLeft from 'react-feather/dist/icons/chevron-left';
import ChevronRight from 'react-feather/dist/icons/chevron-right';
import ChevronsLeft from 'react-feather/dist/icons/chevrons-left';
import ChevronsRight from 'react-feather/dist/icons/chevrons-right';
import ChevronUp from 'react-feather/dist/icons/chevron-up';
import Circle from 'react-feather/dist/icons/circle';
import Clipboard from 'react-feather/dist/icons/clipboard';
import Clock from 'react-feather/dist/icons/clock';
import Code from 'react-feather/dist/icons/code';
import Coffee from 'react-feather/dist/icons/coffee';
import Copy from 'react-feather/dist/icons/copy';
import CornerDownRight from 'react-feather/dist/icons/corner-down-right';
import Crop from 'react-feather/dist/icons/crop';
import Crosshair from 'react-feather/dist/icons/crosshair';
import Download from 'react-feather/dist/icons/download';
import DollarSign from 'react-feather/dist/icons/dollar-sign';
import Edit from 'react-feather/dist/icons/edit';
import ExternalLink from 'react-feather/dist/icons/external-link';
import Eye from 'react-feather/dist/icons/eye';
import EyeOff from 'react-feather/dist/icons/eye-off';
import FastForward from 'react-feather/dist/icons/fast-forward';
import Feather from 'react-feather/dist/icons/feather';
import File from 'react-feather/dist/icons/file';
import FilePlus from 'react-feather/dist/icons/file-plus';
import FileText from 'react-feather/dist/icons/file-text';
import Film from 'react-feather/dist/icons/film';
import Filter from 'react-feather/dist/icons/filter';
import Flag from 'react-feather/dist/icons/flag';
import Folder from 'react-feather/dist/icons/folder';
import Globe from 'react-feather/dist/icons/globe';
import Gift from 'react-feather/dist/icons/gift';
import Hash from 'react-feather/dist/icons/hash';
import Headphones from 'react-feather/dist/icons/headphones';
import Heart from 'react-feather/dist/icons/heart';
import HelpCircle from 'react-feather/dist/icons/help-circle';
import Home from 'react-feather/dist/icons/home';
import Image from 'react-feather/dist/icons/image';
import Info from 'react-feather/dist/icons/info';
import Layers from 'react-feather/dist/icons/layers';
import Layout from 'react-feather/dist/icons/layout';
import List from 'react-feather/dist/icons/list';
import Loader from 'react-feather/dist/icons/loader';
import Lock from 'react-feather/dist/icons/lock';
import Logout from 'react-feather/dist/icons/log-out';
import Mail from 'react-feather/dist/icons/mail';
import Map from 'react-feather/dist/icons/map';
import MapPin from 'react-feather/dist/icons/map-pin';
import Maximize2 from 'react-feather/dist/icons/maximize-2';
import Meh from 'react-feather/dist/icons/meh';
import Menu from 'react-feather/dist/icons/menu';
import MessageCircle from 'react-feather/dist/icons/message-circle';
import Minus from 'react-feather/dist/icons/minus';
import MinusCircle from 'react-feather/dist/icons/minus-circle';
import Monitor from 'react-feather/dist/icons/monitor';
import MoreVertical from 'react-feather/dist/icons/more-vertical';
import MoreHorizontal from 'react-feather/dist/icons/more-horizontal';
import Moon from 'react-feather/dist/icons/moon';
import Music from 'react-feather/dist/icons/music';
import Navigation from 'react-feather/dist/icons/navigation';
import Paperclip from 'react-feather/dist/icons/paperclip';
import PauseCircle from 'react-feather/dist/icons/pause-circle';
import PenTool from 'react-feather/dist/icons/pen-tool';
import Phone from 'react-feather/dist/icons/phone';
import Play from 'react-feather/dist/icons/play';
import Plus from 'react-feather/dist/icons/plus';
import PlusCircle from 'react-feather/dist/icons/plus-circle';
import PlusSquare from 'react-feather/dist/icons/plus-square';
import Printer from 'react-feather/dist/icons/printer';
import Mic from 'react-feather/dist/icons/mic';
import Radio from 'react-feather/dist/icons/radio';
import Refresh from 'react-feather/dist/icons/refresh-ccw';
import Repeat from 'react-feather/dist/icons/repeat';
import RotateCcw from 'react-feather/dist/icons/rotate-ccw';
import RotateCw from 'react-feather/dist/icons/rotate-cw';
import Save from 'react-feather/dist/icons/save';
import Search from 'react-feather/dist/icons/search';
import Server from 'react-feather/dist/icons/server';
import ShoppingBag from 'react-feather/dist/icons/shopping-bag';
import ShoppingCart from 'react-feather/dist/icons/shopping-cart';
import Settings from 'react-feather/dist/icons/settings';
import Shuffle from 'react-feather/dist/icons/shuffle';
import Slash from 'react-feather/dist/icons/slash';
import Sliders from 'react-feather/dist/icons/sliders';
import Smartphone from 'react-feather/dist/icons/smartphone';
import Smile from 'react-feather/dist/icons/smile';
import Square from 'react-feather/dist/icons/square';
import Star from 'react-feather/dist/icons/star';
import Shield from 'react-feather/dist/icons/shield';
import ThumbsDown from 'react-feather/dist/icons/thumbs-down';
import ThumbsUp from 'react-feather/dist/icons/thumbs-up';
import Tag from 'react-feather/dist/icons/tag';
import ToggleRight from 'react-feather/dist/icons/toggle-right';
import Tool from 'react-feather/dist/icons/tool';
import Trash from 'react-feather/dist/icons/trash';
import TrendingDown from 'react-feather/dist/icons/trending-down';
import TrendingUp from 'react-feather/dist/icons/trending-up';
import Truck from 'react-feather/dist/icons/truck';
import Type from 'react-feather/dist/icons/type';
import TV from 'react-feather/dist/icons/tv'
import Unlock from 'react-feather/dist/icons/unlock';
import UploadCloud from 'react-feather/dist/icons/upload-cloud';
import User from 'react-feather/dist/icons/user';
import UserCheck from 'react-feather/dist/icons/user-check';
import UserPlus from 'react-feather/dist/icons/user-plus';
import Users from 'react-feather/dist/icons/users';
import Video from 'react-feather/dist/icons/video';
import Volume2 from 'react-feather/dist/icons/volume-2';
import VolumeX from 'react-feather/dist/icons/volume-x';
import Watch from 'react-feather/dist/icons/watch';
import X from 'react-feather/dist/icons/x';
import XCircle from 'react-feather/dist/icons/x-circle';
import Zap from 'react-feather/dist/icons/zap';
import ZoomIn from 'react-feather/dist/icons/zoom-in';
import ZoomOut from 'react-feather/dist/icons/zoom-out';

// TODO: Icons that are in the Feather library but not in the Tabler library
// IconArrowUpRigh
// IconBookOpen
// IconCheckCircle
// CheckSquare
// DollarSign
// FastForward
// Film
// Image
// Info
// Layers
// Maximize2
// Meh
// MinusCircle
// Monitor
// MoreVertical
// MoreHorizontal
// PauseCircle
// PenTool
// PlusCircle
// PlusSquare
// Play
// Mic
// RotateCcw
// RotateCw
// Save
// Shuffle
// Sliders
// Smartphone
// Smile
// ThumbsDown
// ThumbsUp
// Type
// TV
// Unlock
// UploadCloud
// VolumeX
// Watch
// XCircle
// Zap

// Icons from library of Tabler
import { IconActivity } from '@tabler/icons-react';
import { IconAlertCircle } from '@tabler/icons-react';
import { IconAlertTriangle } from '@tabler/icons-react';
import { IconAlertOctagon } from '@tabler/icons-react';
import { IconAlignCenter } from '@tabler/icons-react';
import { IconAlignLeft } from '@tabler/icons-react';
import { IconAlignRight } from '@tabler/icons-react';
import { IconArchive } from '@tabler/icons-react';
import { IconArrowDownRight } from '@tabler/icons-react';
import { IconArrowLeft } from '@tabler/icons-react';
import { IconArrowLeftCircle } from '@tabler/icons-react';
import { IconArrowRight } from '@tabler/icons-react';
import { IconArrowRightCircle } from '@tabler/icons-react';
import { IconAward } from '@tabler/icons-react';
import { IconBatteryCharging } from '@tabler/icons-react';
import { IconBellOff } from '@tabler/icons-react';
import { IconBell } from '@tabler/icons-react';
import { IconCalendar } from '@tabler/icons-react';
import { IconCamera } from '@tabler/icons-react';
import { IconCameraOff } from '@tabler/icons-react';
import { IconCheck } from '@tabler/icons-react';
import { IconChevronDown } from '@tabler/icons-react';
import { IconChevronLeft } from '@tabler/icons-react';
import { IconChevronRight } from '@tabler/icons-react';
import { IconChevronsLeft } from '@tabler/icons-react';
import { IconChevronsRight } from '@tabler/icons-react';
import { IconChevronUp } from '@tabler/icons-react';
import { IconCircle } from '@tabler/icons-react';
import { IconClipboard } from '@tabler/icons-react';
import { IconClock } from '@tabler/icons-react';
import { IconCode } from '@tabler/icons-react';
import { IconCoffee } from '@tabler/icons-react';
import { IconCopy } from '@tabler/icons-react';
import { IconCornerDownRight } from '@tabler/icons-react';
import { IconCrop } from '@tabler/icons-react';
import { IconCrosshair } from '@tabler/icons-react';
import { IconDownload } from '@tabler/icons-react';
import { IconEdit } from '@tabler/icons-react';
import { IconExternalLink } from '@tabler/icons-react';
import { IconEye } from '@tabler/icons-react';
import { IconEyeOff } from '@tabler/icons-react';
import { IconFeather } from '@tabler/icons-react';
import { IconFile } from '@tabler/icons-react';
import { IconFilePlus } from '@tabler/icons-react';
import { IconFileText } from '@tabler/icons-react';
import { IconFilter } from '@tabler/icons-react';
import { IconFlag } from '@tabler/icons-react';
import { IconFolder } from '@tabler/icons-react';
import { IconGlobe } from '@tabler/icons-react';
import { IconGift } from '@tabler/icons-react';
import { IconHash } from '@tabler/icons-react';
import { IconHeadphones } from '@tabler/icons-react';
import { IconHeart } from '@tabler/icons-react';
import { IconHelpCircle } from '@tabler/icons-react';
import { IconHome } from '@tabler/icons-react';
import { IconLayout } from '@tabler/icons-react';
import { IconLayoutSidebarRightCollapse } from '@tabler/icons-react';
import { IconLayoutSidebarLeftCollapse } from '@tabler/icons-react';
import { IconLayoutSidebarRightExpand } from '@tabler/icons-react';
import { IconLayoutSidebarLeftExpand } from '@tabler/icons-react';
import { IconList } from '@tabler/icons-react';
import { IconLoader } from '@tabler/icons-react';
import { IconLock } from '@tabler/icons-react';
import { IconLogout } from '@tabler/icons-react';
import { IconMail } from '@tabler/icons-react';
import { IconMap } from '@tabler/icons-react';
import { IconMapPin } from '@tabler/icons-react';
import { IconMenu } from '@tabler/icons-react';
import { IconMessageCircle } from '@tabler/icons-react';
import { IconMinus } from '@tabler/icons-react';
import { IconMoon } from '@tabler/icons-react';
import { IconMusic } from '@tabler/icons-react';
import { IconNavigation } from '@tabler/icons-react';
import { IconPaperclip } from '@tabler/icons-react';
import { IconPhone } from '@tabler/icons-react';
import { IconPlus } from '@tabler/icons-react';
import { IconPrinter } from '@tabler/icons-react';
import { IconRadio } from '@tabler/icons-react';
import { IconRefresh } from '@tabler/icons-react';
import { IconRepeat } from '@tabler/icons-react';
import { IconSearch } from '@tabler/icons-react';
import { IconServer } from '@tabler/icons-react';
import { IconShoppingBag } from '@tabler/icons-react';
import { IconShoppingCart } from '@tabler/icons-react';
import { IconSettings } from '@tabler/icons-react';
import { IconSlash } from '@tabler/icons-react';
import { IconSquare } from '@tabler/icons-react';
import { IconStar } from '@tabler/icons-react';
import { IconShield } from '@tabler/icons-react';
import { IconTag } from '@tabler/icons-react';
import { IconToggleRight } from '@tabler/icons-react';
import { IconTool } from '@tabler/icons-react';
import { IconTrash } from '@tabler/icons-react';
import { IconTrendingDown } from '@tabler/icons-react';
import { IconTrendingUp } from '@tabler/icons-react';
import { IconTruck } from '@tabler/icons-react';
import { IconUser } from '@tabler/icons-react';
import { IconUserCheck } from '@tabler/icons-react';
import { IconUserPlus } from '@tabler/icons-react';
import { IconUsers } from '@tabler/icons-react';
import { IconVideo } from '@tabler/icons-react';
import { IconVolume2 } from '@tabler/icons-react';
import { IconX } from '@tabler/icons-react';
import { IconZoomIn } from '@tabler/icons-react';
import { IconZoomOut } from '@tabler/icons-react';

export {
  Activity,
  AlertCircle,
  AlertOctagon,
  AlertTriangle,
  AlignCenter,
  AlignLeft,
  AlignRight,
  Archive,
  ArrowDownRight,
  ArrowLeft,
  ArrowLeftCircle,
  ArrowRight,
  ArrowRightCircle,
  ArrowUpRight,
  Award,
  BatteryCharging,
  Bell,
  BellOff,
  BookOpen,
  Calendar,
  Camera,
  CameraOff,
  Check,
  CheckCircle,
  CheckSquare,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
  ChevronUp,
  Circle,
  Clipboard,
  Clock,
  Code,
  Coffee,
  Copy,
  CornerDownRight,
  Crop,
  Crosshair,
  Download,
  DollarSign,
  Edit,
  ExternalLink,
  Eye,
  EyeOff,
  FastForward,
  Feather,
  File,
  FilePlus,
  FileText,
  Film,
  Filter,
  Folder,
  Flag,
  Gift,
  Globe,
  Hash,
  Headphones,
  Heart,
  HelpCircle,
  Home,
  Image,
  Mic,
  Info,
  Layers,
  Layout,
  List,
  Loader,
  Lock,
  Logout,
  Mail,
  Map,
  MapPin,
  Maximize2,
  Meh,
  Menu,
  MessageCircle,
  Minus,
  MinusCircle,
  Monitor,
  MoreVertical,
  MoreHorizontal,
  Moon,
  Music,
  Navigation,
  Paperclip,
  PauseCircle,
  PenTool,
  Phone,
  Play,
  Plus,
  PlusCircle,
  PlusSquare,
  Printer,
  Radio,
  Refresh,
  Repeat,
  RotateCcw,
  RotateCw,
  Save,
  Search,
  Server,
  ShoppingBag,
  ShoppingCart,
  Settings,
  Shuffle,
  Slash,
  Sliders,
  Smartphone,
  Smile,
  Square,
  Star,
  Shield,
  ThumbsDown,
  ThumbsUp,
  Tag,
  ToggleRight,
  Tool,
  Trash,
  TrendingDown,
  TrendingUp,
  Truck,
  Type,
  TV,
  Unlock,
  UploadCloud,
  User,
  UserCheck,
  UserPlus,
  Users,
  Video,
  Volume2,
  VolumeX,
  Watch,
  X,
  XCircle,
  Zap,
  ZoomIn,
  ZoomOut,

  //Icons from library of Tabler
  IconActivity,
  IconAlertCircle,
  IconAlertTriangle,
  IconAlertOctagon,
  IconAlignCenter,
  IconAlignLeft,
  IconAlignRight,
  IconArchive,
  IconArrowDownRight,
  IconArrowLeft,
  IconArrowLeftCircle,
  IconArrowRight,
  IconArrowRightCircle,
  IconAward,
  IconBatteryCharging,
  IconBellOff,
  IconBell,
  IconCalendar,
  IconCamera,
  IconCameraOff,
  IconCheck,
  IconChevronDown,
  IconChevronLeft,
  IconChevronRight,
  IconChevronsLeft,
  IconChevronsRight,
  IconChevronUp,
  IconCircle,
  IconClipboard,
  IconClock,
  IconCode,
  IconCoffee,
  IconCopy,
  IconCornerDownRight,
  IconCrop,
  IconCrosshair,
  IconDownload,
  IconEdit,
  IconExternalLink,
  IconEye,
  IconEyeOff,
  IconFeather,
  IconFile,
  IconFilePlus,
  IconFileText,
  IconFilter,
  IconFlag,
  IconFolder,
  IconGlobe,
  IconGift,
  IconHash,
  IconHeadphones,
  IconHeart,
  IconHelpCircle,
  IconHome,
  IconLayout,
  IconLayoutSidebarRightCollapse,
  IconLayoutSidebarLeftCollapse,
  IconLayoutSidebarRightExpand,
  IconLayoutSidebarLeftExpand,
  IconList,
  IconLoader,
  IconLock,
  IconLogout,
  IconMail,
  IconMap,
  IconMapPin,
  IconMenu,
  IconMessageCircle,
  IconMinus,
  IconMoon,
  IconMusic,
  IconNavigation,
  IconPaperclip,
  IconPhone,
  IconPlus,
  IconPrinter,
  IconRadio,
  IconRefresh,
  IconRepeat,
  IconSearch,
  IconServer,
  IconShoppingBag,
  IconShoppingCart,
  IconSettings,
  IconSlash,
  IconSquare,
  IconStar,
  IconShield,
  IconTag,
  IconToggleRight,
  IconTool,
  IconTrash,
  IconTrendingDown,
  IconTrendingUp,
  IconTruck,
  IconUser,
  IconUserCheck,
  IconUserPlus,
  IconUsers,
  IconVideo,
  IconVolume2,
  IconX,
  IconZoomIn,
  IconZoomOut,
};
